export const getMessageSlice = (state) => state.message;

/**
 * Helper to safely extract message text from message object
 * @param {object|string} message - Message from Redux state
 * @returns {string} - Safe message text
 */
export const getMessageText = (message) => {
  if (!message) return "";
  if (typeof message === "string") return sanitizeApiErrorMessage(message);
  if (typeof message === "object") {
    const text = message?.text || message?.message || "";
    return text ? sanitizeApiErrorMessage(text) : "خطایی رخ داده است.";
  }
  return "خطایی رخ داده است.";
};

const sanitizeApiErrorMessage = (text) => {
  if (!text) return "";

  const trimmed = String(text).trim();
  if (trimmed.startsWith("{")) {
    try {
      const parsed = JSON.parse(trimmed);
      const exception = parsed?.Exception || parsed?.exception || "";
      if (/authentication|unauthorized|token/i.test(exception)) {
        return "نشست شما منقضی شده است. لطفاً دوباره وارد شوید.";
      }
      if (parsed?.message) return sanitizeApiErrorMessage(parsed.message);
      if (exception && !/ at /i.test(exception)) return exception;
      return "خطایی رخ داده است. لطفاً دوباره تلاش کنید.";
    } catch {
      return "خطایی رخ داده است. لطفاً دوباره تلاش کنید.";
    }
  }

  if (/^Authentication failed\.?$/i.test(trimmed) || /^Authenticate failed\.?$/i.test(trimmed)) {
    return "نشست شما منقضی شده است. لطفاً دوباره وارد شوید.";
  }

  if (/StackTrace| at WebFramework| at Microsoft\./i.test(trimmed)) {
    return "خطایی رخ داده است. لطفاً دوباره تلاش کنید.";
  }

  return trimmed;
};

/**
 * Helper to get message severity
 * @param {object|string} message - Message from Redux state
 * @returns {string} - Severity type (error, warning, info, success)
 */
export const getMessageSeverity = (message) => {
  if (!message) return "error";
  if (typeof message === "object") {
    return message?.type || "error";
  }
  return "error";
};
